import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const getAllVendorCampaign = async (user, page, page_size, vendor_id, from_date, till_date) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
        const mode = localStorage.getItem('mode')
        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `/service/campaign_service/v1/campaign/super_admin/campaign_report`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
            params: { page, vendor_id, page_size, mode, from_date, till_date }
        };
        const response = await axios.request(config);
        return response.data;
    } catch (err) {
        console.log(err);

    }
};

export default getAllVendorCampaign;
